import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  createMuiTheme,
  MuiThemeProvider,
  TextField,
  Tooltip,
  Card as CardMaterial,
  CardMedia,
  Typography,
  Chip,
} from "@material-ui/core";
import { Delete, Visibility, GetApp } from "@material-ui/icons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteImagen,
  getImagenById,
  postImagen,
  updateImagen,
} from "../../../../api/imagen";
import Select from "react-select";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { checkIsEmpty } from "../../../../utils/helpers";
import { SERVER_URL } from "../../../../api";
import { buttonsStyle } from "../../../components/tables/table";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyImagen() {
  return {
    titulo: "",
    url: "",
    tipo: "imagen", // Por defecto 'imagen', pero puede ser 'archivo'
    tipoArchivo: "",
    etiquetas: [],
  };
}

export default function EditImagenesPage() {
  const [imagen, setImagen] = useState(getEmptyImagen());
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const imagenId = useParams().id;
  const history = useHistory();

  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImages] = useState(null);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [tagInput, setTagInput] = useState(""); // Input temporal para escribir tags

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!imagenId) {
      disableLoadingData();
      return;
    }
    getImagenById(imagenId)
      .then((res) => {
        if (res.status === 200) {
          const imagenData = {
            ...res.data,
            etiquetas: Array.isArray(res.data.etiquetas) ? res.data.etiquetas : []
          };
          setImagen(imagenData);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la imagen.",
        });
        history.push("/imagenes");
      });
  }, [imagenId, disableLoadingData, history]);

  function saveImagen() {
    if (!selectedImage && !imagen.url)
      return alertError({
        error: null,
        customMessage: "El archivo es requerido.",
      });
    
    // Detectar tipo automáticamente si no está especificado
    if (!imagen.tipo && selectedImage) {
      const fileName = selectedImage.name.toLowerCase();
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico'];
      imagen.tipo = imageExtensions.some(ext => fileName.endsWith(ext)) ? 'imagen' : 'archivo';
      
      if (imagen.tipo === 'archivo') {
        const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
        if (extension && extension.length <= 10) {
          imagen.tipoArchivo = extension;
        }
      }
    } else if (!imagen.tipo && imagen.url) {
      const url = imagen.url.toLowerCase();
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico'];
      imagen.tipo = imageExtensions.some(ext => url.endsWith(ext)) ? 'imagen' : 'archivo';
      
      if (imagen.tipo === 'archivo') {
        const extension = url.substring(url.lastIndexOf('.') + 1);
        if (extension && extension.length <= 10) {
          imagen.tipoArchivo = extension;
        }
      }
    }
    
    // Asegurar que etiquetas sea un array
    const imagenToSave = {
      ...imagen,
      etiquetas: Array.isArray(imagen.etiquetas) ? imagen.etiquetas : [],
    };

    if (!imagenId) {
      postImagen(imagenToSave, selectedImage)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: imagen.tipo === 'imagen' ? "Imagen creada correctamente." : "Archivo creado correctamente.",
            });
            history.push("/imagenes");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guardar el archivo.",
          });
        });
    } else {
      updateImagen(imagenId, imagenToSave, selectedImage)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Los cambios se han guardado correctamente.",
            });
            history.push("/imagenes");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }
  const handleChange = (element) => (event) => {
    setImagen({ ...imagen, [element]: event.target.value });
  };

  const handleTagInputKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addTag();
    }
  };

  const addTag = () => {
    const tagValue = tagInput.trim().toLowerCase();
    if (tagValue) {
      const currentTags = imagen.etiquetas || [];
      if (!currentTags.includes(tagValue)) {
        setImagen({ ...imagen, etiquetas: [...currentTags, tagValue] });
      }
      setTagInput("");
    }
  };

  const removeTag = (tagToRemove) => {
    const currentTags = imagen.etiquetas || [];
    const newTags = currentTags.filter(tag => tag !== tagToRemove);
    setImagen({ ...imagen, etiquetas: newTags });
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/imagenes"),
            onSave: saveImagen,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!imagenId,
            setObj: setImagen,
            obj: imagen,
          })}
          <CardHeader title="Editar imagen"></CardHeader>
          <CardBody>
            <TextField
              id={`titulo`}
              label="Titulo"
              value={imagen.titulo}
              onChange={handleChange("titulo")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
              fullWidth
            />
            <div style={{ marginTop: "16px", marginBottom: "8px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "14px", color: "#333" }}>
                Etiquetas
              </label>
              <div style={{ 
                border: "1px solid #ced4da", 
                borderRadius: "4px", 
                padding: "8px",
                minHeight: "56px",
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
                alignItems: "center",
                backgroundColor: "#fff"
              }}>
                {(imagen.etiquetas || []).map((tag, index) => (
                  <Chip
                    key={index}
                    label={tag}
                    onDelete={() => removeTag(tag)}
                    size="small"
                    style={{ 
                      backgroundColor: "#f3691a",
                      color: "#fff",
                      fontSize: "12px",
                      height: "28px"
                    }}
                  />
                ))}
                <TextField
                  value={tagInput}
                  onChange={(e) => setTagInput(e.target.value)}
                  onKeyDown={handleTagInputKeyDown}
                  placeholder={(imagen.etiquetas || []).length === 0 ? "Escribe una etiqueta y presiona Enter..." : "Añadir otra etiqueta..."}
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                    style: { fontSize: "14px" }
                  }}
                  style={{ 
                    flex: 1,
                    minWidth: "150px"
                  }}
                />
              </div>
              <Typography variant="caption" style={{ color: "#666", marginTop: "4px", display: "block" }}>
                Escribe una etiqueta y presiona Enter o coma para añadirla
              </Typography>
            </div>
            <div className="col-md-12">
              <CardMaterial>
                {(selectedImage || imagen.url) && (
                  <>
                    {imagen.tipo === 'imagen' || (!imagen.tipo && (selectedImage?.type?.startsWith('image/') || imagen.url?.match(/\.(jpg|jpeg|png|gif|bmp|webp|svg|ico)$/i))) ? (
                      <CardMedia
                        component="img"
                        alt="Imagen"
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          height: "auto",
                          maxHeight: "600px",
                        }}
                        image={
                          selectedImage
                            ? URL.createObjectURL(selectedImage)
                            : `${SERVER_URL}/${imagen.url}`
                        }
                      />
                    ) : (
                      <div style={{
                        padding: "40px",
                        textAlign: "center",
                        backgroundColor: "#f5f5f5",
                        minHeight: "200px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <GetApp style={{ fontSize: 64, color: "#757575", marginBottom: "16px" }} />
                        <Typography variant="h6" style={{ marginBottom: "8px" }}>
                          {imagen.titulo || "Archivo"}
                        </Typography>
                        {imagen.tipoArchivo && (
                          <Typography variant="body2" style={{ color: "#666" }}>
                            Tipo: {imagen.tipoArchivo.toUpperCase()}
                          </Typography>
                        )}
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<GetApp />}
                          style={{ marginTop: "16px" }}
                          onClick={() => window.open(`${SERVER_URL}/${imagen.url}`, '_blank')}
                        >
                          Descargar archivo
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </CardMaterial>
              <label htmlFor={"upload-media"} className="ml-0 my-4">
                <input
                  style={{ display: "none" }}
                  id={"upload-media"}
                  name={"upload-media"}
                  type="file"
                  accept={"image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"}
                  onChange={(e) => {
                    setSelectedImage(e.target.files[0]);
                  }}
                />
                <Button
                  style={{ marginRight: "15px" }}
                  color="secondary"
                  component="span"
                  variant="outlined"
                >
                  {selectedImage || (imagen.url && imagen.url !== "")
                    ? "Cambiar archivo"
                    : "Subir archivo"}
                </Button>
              </label>
              {(selectedImage || (imagen.url && imagen.url !== "")) && (
                <>
                  <Tooltip title={"Preview"}>
                    <Button
                      size="small"
                      onClick={() => setOpenPreviewDialog(1)}
                      style={{
                        ...buttonsStyle,
                        marginRight: "15px",
                      }}
                    >
                      <Visibility />
                    </Button>
                  </Tooltip>
                  <PreviewDialog
                    title={"Preview"}
                    open={openPreviewDialog === 1}
                    setOpen={setOpenPreviewDialog}
                    file={selectedImage}
                    src={
                      selectedImage
                        ? URL.createObjectURL(selectedImage)
                        : `${SERVER_URL}/${imagen.url}`
                    }
                  />
                  <PreviewDialog
                    title={"Preview"}
                    open={openPreviewDialog === 2}
                    setOpen={setOpenPreviewDialog}
                    file={previewImage}
                    src={`${SERVER_URL}/${previewImage}`}
                  />
                  <Tooltip title={"Delete"}>
                    <Button
                      size="small"
                      onClick={() => {
                        setSelectedImage(null);
                        setImagen({
                          ...imagen,
                          url: null,
                        });
                      }}
                    >
                      <Delete />
                    </Button>
                  </Tooltip>
                </>
              )}
            </div>
          </CardBody>
        </Card>
        <div style={{ display: "flex", flexDirection: "row" }}>
          {imagenId && (
            <>
              <ConfirmDialog
                title={"¿Estás seguro de que quieres eliminar esta imagen?"}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                  deleteImagen(imagenId)
                    .then((res) => {
                      if (res.status === 204 || res.status === 200) {
                        alertSuccess({
                          title: "¡Eliminada!",
                          customMessage: "Imagen eliminada correctamente",
                        });
                        history.push("/imagenes");
                      }
                    })
                    .catch((error) => {
                      alertError({
                        error: error,
                        customMessage: "No se ha podido eliminar la imagen.",
                      });
                    });
                }}
              />
            </>
          )}
        </div>
      </>
    );
}
